import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import createExportThunk from "slices/captureDashboard/createExportThunk";
import { selectFilters } from "slices/captureDashboard/selectors";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/capture-dashboard/widgets/top-opportunities-by-best-fit";
const LIMIT = 6;
const CSV_FILENAME = "Top Opportunities by Best Fit.csv";
const PDF_FILENAME = "Top Opportunities by Best Fit.pdf";

export const fetchTopOpportunitiesByBestFit = createAsyncThunk(
  "topOpportunitiesByBestFit/fetch",
  async (_, { getState }) => {
    const filters = selectFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd, limit: LIMIT },
    });
    return data;
  },
);

export const exportTopOpportunitiesByBestFitCsv = createExportThunk(BASE_URL, "csv", CSV_FILENAME);
export const exportTopOpportunitiesByBestFitPdf = createExportThunk(BASE_URL, "pdf", PDF_FILENAME);
